import React from "react";
import office from "../../assets/images/CDCHospital.png";
import LocationIconTilt from "./LocationIconTilt";

export default function ContactUs() {
  return (
    <div className="pt-[9.75rem] pb-24">
      <div className="px-[2.5rem] block w-full mx-auto xl:pb-[20rem]">
        <div className="flex justify-center items-center w-full">
          <div className="xl:w-4/5 w-full   grid lg:grid-cols-2 grid-cols-1">
            <div className="">
              <h1
                data-aos="fade-up"
                className="xl:text-left lg:w-[80%] w-full text-left sm:text-center
                font-Antique  text-white sm:text-5xl  md:text-7xl 2xl:text-[8.25rem] 2xl:leading-[144px] text-5xl tracking-[-.03em] lowercase mt-[.25rem]"
              >
                <span>get in</span> <br />
                <span className="ml-[8.5rem]">touch</span>
              </h1>
            </div>
            <div className="lg:mt-24 md:mt-16 mt-12 flex justify-center items-center leading-[1.4] text-[1.4rem] tracking-[-.05em] font-Matter text-white">
              <div
                data-aos="fade-up"
                data-aso-delay="200"
                className="md:w-4/5 w-full"
              >
                <p>
                  Got any Questions related to your diagnostic concerns?
                  <br />
                  <br />
                  A precision diagnostic is just in your neighbourhood- a call &
                  message away.
                  <br />
                  <br />
                  Your health journey starts with the right care and the right
                  step.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute lg:block hidden lg:top-[20rem] xl:top-[24rem] 2xl:top-[28rem] 2xl:left-[11.5rem] -z-[1]">
          <div>
            <div
              className=" rounded-[2rem] opacity-[1] bg-transparent md:w-4/5 lg:w-[24rem] lg:h-[16rem] xl:w-[35rem] xl:h-[23.5rem] overflow-hidden "
              style={{ transform: "rotate(-8deg)" }}
            >
              <picture>
                <img
                  src={office}
                  data-aos="zoom-in"
                  data-aso-delay="200"
                  alt=""
                  className="w-full h-full object-cover"
                />
              </picture>
            </div>
            <LocationIconTilt />
          </div>
        </div>
      </div>
    </div>
  );
}
